import { Auth0Context, type Auth0ContextInterface, initialContext } from '@auth0/auth0-react';
import type { ReactNode } from 'react';
import { fixedTokenAccessor } from './fixed-token-accessor';

const DEMO_HOST = import.meta.env.VITE_DEMO_HOSTNAME;

export function isDemoMode(): boolean {
  return window.location.host === DEMO_HOST;
}

const DEMO_TOKEN = 'demo-access-token';

const demoUser = {
  email: 'demo@liquorstore.tech',
  sub: 'demo|000000000000000000000000',
  name: 'Demo User',
};

const demoContext: Auth0ContextInterface = {
  ...initialContext,
  isAuthenticated: true,
  isLoading: false,
  user: demoUser,
  getAccessTokenSilently: fixedTokenAccessor(DEMO_TOKEN),
  loginWithRedirect: () => Promise.resolve(),
  logout: () => Promise.resolve(),
};

export function DemoAuthProvider({ children }: { children: ReactNode }) {
  return <Auth0Context.Provider value={demoContext}>{children}</Auth0Context.Provider>;
}
